import { render, staticRenderFns } from "./OrmBatchingListSideMenu.vue?vue&type=template&id=fea0d7c2&scoped=true"
import script from "./OrmBatchingListSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmBatchingListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchingListSideMenu.vue?vue&type=style&index=0&id=fea0d7c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea0d7c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fea0d7c2')) {
      api.createRecord('fea0d7c2', component.options)
    } else {
      api.reload('fea0d7c2', component.options)
    }
    module.hot.accept("./OrmBatchingListSideMenu.vue?vue&type=template&id=fea0d7c2&scoped=true", function () {
      api.rerender('fea0d7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingListSideMenu.vue"
export default component.exports